import { observable, runInAction } from 'mobx';
import { get } from '../utils';

class BagList {
    private route: string;
    @observable
    public BagListData: any;

    constructor(params: any) {
        this.route = params.url;
    }

    async fetch(callback?, errs?) {

        get(this.route).then((d) => {
            let data;
            if (d.data) {
                data = d.data;
                runInAction(() => {
                    this.BagListData = data;
                    callback && (this.BagListData = callback(data));
                });
            } else {
                callback && callback([]);
            }
        }).catch((err) => {
            errs && errs(err);
        });
    }

}

export default BagList;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/model/BagList.ts